<script lang="ts" module>
  import type { MouseEventHandler } from 'svelte/elements';

  import MarkerPill from './MarkerPill.svelte';

  export interface MarkerPillPerspectiveProps {
    labelSender: string;
    labelReceiver: string;
    valueSender: number;
    valueReceiver: number;
    onClickSender: MouseEventHandler<HTMLButtonElement>;
    onClickReceiver: MouseEventHandler<HTMLButtonElement>;
    selected?: boolean;
    disabled?: boolean;
  }
</script>

<script lang="ts">
  let {
    disabled = false,
    selected: selectedProp = $bindable(false),
    ...props
  }: MarkerPillPerspectiveProps = $props();

  let isDisabled = $derived(disabled || (props.valueReceiver === 0 && props.valueSender === 0));
</script>

<div class="fc gap-2">
  <p class="text-label-sm font-normal text-c-base">Perspektive:</p>
  <div class="fr gap-1">
    <MarkerPill
      label={props.labelSender}
      onclick={props.onClickSender}
      percentage={true}
      variant="subdim2"
      value={props.valueSender}
      bind:selected={selectedProp}
      disabled={isDisabled}
    ></MarkerPill>
    <MarkerPill
      label={props.labelReceiver}
      onclick={props.onClickReceiver}
      percentage={true}
      variant="subdim3"
      value={props.valueReceiver}
      bind:selected={selectedProp}
      disabled={isDisabled}
    ></MarkerPill>
  </div>
</div>
